import styled from 'styled-components'

export const DateTimeStyled = styled.p``
